import * as React from 'react';
import { RouteComponentProps, withRouter, Link, NavLink, Redirect } from 'react-router-dom';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import bindAllOfThis from 'src/utils/BindThisHelper';
import Routes from 'src/core/Routes';
import { PageProps } from "src/models/common/ComponentProps";
import { ReduxStoreModel } from "src/redux/ReduxModel";
import { Form, Row, Col, Select, Icon, Radio, Button } from "antd";
import UserAction from "src/redux/UserActions";
import CheckpointAction from "src/redux/CheckpointActions";
import UserMeInfo from "src/models/account/UserMeInfo";
import { UserState } from "src/redux/UserReducer";
import { MissionState } from "src/redux/CheckpointReducer";
import { Grades, Grade } from "src/constants/Grades";
import { Planets, Planet } from "src/constants/Planets";
import { Checkpoints, Checkpoint } from "src/constants/Checkpoints";
import { RadioChangeEvent } from "antd/lib/radio";
import SimpleCheckpointStatusDTO from 'src/models/frontend/redux/SimpleCheckpointStatusDTO';
import FullCheckpointStatusDTO from 'src/models/frontend/redux/FullCheckpointStatusDTO';
import CheckpointStatusDTO from 'src/models/frontend/redux/CheckpointStatusDTO';
import { Translate } from 'react-localize-redux';

interface StudentViewsState {
    gradeId: number;
    checkpointId: number;
    planetId: number;
}

interface StudentViewsProps extends PageProps<{}> {
    // From Redux
    User: UserState;
    Mission: MissionState;
    setLogin: (request: UserMeInfo) => void;
    setCheckpoint: (request: FullCheckpointStatusDTO) => void;
    startReplay: (start: CheckpointStatusDTO, end: CheckpointStatusDTO, returnLocation: string) => void;
}

class StudentViews extends React.Component<StudentViewsProps, StudentViewsState> {
    constructor(props: StudentViewsProps) {
        super(props);
        bindAllOfThis(this, StudentViews.prototype);

        this.state = {
            gradeId: Grades.PreK.id,
            planetId: Planets.R.id,
            checkpointId: Checkpoints.Video.id
        };
    }

    handleGradeChange(value: RadioChangeEvent) {
        this.setState({
            gradeId: value.target.value
        });
    }

    handlePlanetChange(value: RadioChangeEvent) {
        this.setState({
            planetId: value.target.value
        });
    }

    handleCheckpointChange(value: RadioChangeEvent) {
        this.setState({
            checkpointId: value.target.value
        });
    }

    renderGrades() {
        var grades = Grades.All;
        return <Radio.Group value={grades.find((g: Grade) => g.id === this.state.gradeId).id} onChange={this.handleGradeChange} buttonStyle="solid">
            {grades.map(grade => <Radio.Button value={grade.id} key={grade.id}>{grade.name}</Radio.Button>)}
        </Radio.Group>;
    }

    renderPlanet() {
        var planets = Planets.All;
        return <Radio.Group value={planets.find((p: Planet) => p.id === this.state.planetId).id} onChange={this.handlePlanetChange} buttonStyle="solid">
            {planets.map(planet => <Radio.Button value={planet.id} key={planet.id}  >{planet.name}</Radio.Button>)}
        </Radio.Group>;
    }

    renderCheckpoint() {
        var checkpoints = [Checkpoints.Video, Checkpoints.Game, Checkpoints.Activity];
        return <Radio.Group value={checkpoints.find((c: Checkpoint) => c.id === this.state.checkpointId).id} onChange={this.handleCheckpointChange} buttonStyle="solid">
            {checkpoints.map(checkpoint => <Radio.Button value={checkpoint.id} key={checkpoint.id}>{checkpoint.name}</Radio.Button>)}
        </Radio.Group>;
    }

    renderGrid() {
        let items: { name: string, value: any }[] = [
            { name: "Grade", value: this.renderGrades() },
            { name: "Planet", value: this.renderPlanet() },
            { name: "Checkpoint", value: this.renderCheckpoint() },
        ];

        return items.map(item => {
            return <Row key={item.name} className="grid-items">
                <Col sm={4} md={6} lg={4} xl={2}>{item.name}</Col>
                <Col sm={20} md={18} lg={20} xl={22}>{item.value}</Col>
            </Row>;
        });
    }

    viewAsStudent() {
        // Set correct grade
        this.props.setLogin({
            ...this.props.User,
            gradeId: this.state.gradeId
        });

        // Set debug checkpoint status
        this.props.setCheckpoint({
            ...this.props.Mission,
            current: {
                checkpointId: this.state.checkpointId,
                planetId: this.state.planetId,
                stepId: 1
            },
            currentDirection: "forwards",
        });

        // Set the start and end checkpoints
        let replayStart: CheckpointStatusDTO = {
            planetId: this.state.planetId,
            checkpointId: this.state.checkpointId,
            stepId: 1
        };
        let replayEnd: CheckpointStatusDTO = {
            planetId: this.state.planetId,
            checkpointId: this.state.checkpointId + 1,
            stepId: 1
        };

        this.props.startReplay(replayStart, replayEnd, Routes.ADMIN_STUDENT_VIEWS);
        this.props.history.push(Routes.STUDENT_HOME);
    }

    render() {
        return <div className="student-views">
            <h2><Translate id="admin.studentViews.header" /></h2>
            <p><Translate id="admin.studentViews.body1" /></p>
            <p><Translate id="admin.studentViews.body2" /></p>
            <p><Translate id="admin.studentViews.body3" /></p>
            <br />
            {this.renderGrid()}
            <Button type="primary" onClick={this.viewAsStudent}>View As Student</Button>
        </div>;
    }
}

function mapDispatchToProps(dispatch: Dispatch<any>) {
    return ({
        setLogin: (request: UserMeInfo) => UserAction.SetLogin(dispatch, request),
        setCheckpoint: (request: FullCheckpointStatusDTO) => CheckpointAction.SetUserStatus(dispatch, request),
        startReplay: (start: CheckpointStatusDTO, end: CheckpointStatusDTO, returnLocation: string) => CheckpointAction.StartReplay(dispatch, start, end, returnLocation),
    });
}

function mapStateToProps(state: ReduxStoreModel) {
    return {
        User: state.User,
        Mission: state.Mission,
        Constants: state.Constants
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(StudentViews);



// WEBPACK FOOTER //
// ./src/pages/admin/StudentViews.tsx